const initialShapesList = [
  { id: 0, type: 'circle', x: 30, y: 100 },
  { id: 1, type: 'square', x: 70, y: 100 },
  { id: 2, type: 'circle', x: 110, y: 100 },
];

export { initialShapesList };
